import { useIntl } from 'react-intl';
import IconButtonWithTooltip from '@alltrails/denali/components/IconButtonWithTooltip';
import ZoomIn from '@alltrails/denali/icons/ZoomIn';
import ZoomOut from '@alltrails/denali/icons/ZoomOut';
import useMap from '../../hooks/useMap';
import type MapControlButtonOptions from '../../types/MapControlButtonOptions';

type ZoomButtonsProps = MapControlButtonOptions & {
  onZoomInClick?: () => void;
  onZoomOutClick?: () => void;
};

const ZoomButtons = ({ elevated = true, onZoomInClick, onZoomOutClick, size }: ZoomButtonsProps) => {
  const intl = useIntl();
  const map = useMap();

  return (
    <>
      <IconButtonWithTooltip
        elevated={elevated}
        icon={{ Component: ZoomIn }}
        onClick={() => {
          onZoomInClick?.();
          map?.zoomIn();
        }}
        size={size}
        title={intl.formatMessage({ defaultMessage: 'Zoom map in' })}
        uniqueId="map-zoom-in-button"
        variant="ghost"
      />
      <IconButtonWithTooltip
        elevated={elevated}
        icon={{ Component: ZoomOut }}
        onClick={() => {
          onZoomOutClick?.();
          map?.zoomOut();
        }}
        size={size}
        title={intl.formatMessage({ defaultMessage: 'Zoom map out' })}
        uniqueId="map-zoom-out-button"
        variant="ghost"
      />
    </>
  );
};

export default ZoomButtons;
